module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-right/right-arrow-32e28dd5e6bfe67e192cdf2206afb8c4.svg";